var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.lp)?_c('Form',{attrs:{"model":_vm.lp,"titlePrefix":_vm.$t('forms.title_prefix.edit')},on:{"saved":_vm.saved}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }